export default __webpack_public_path__ + "2b21fc4a920a19fc88379b71618faa81.png";